import { render, staticRenderFns } from "./Mentee.vue?vue&type=template&id=5b5b12a2&"
import script from "./Mentee.vue?vue&type=script&lang=js&"
export * from "./Mentee.vue?vue&type=script&lang=js&"
import style0 from "./Mentee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports